// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2P7YC","left":"styles_left__3WfQz"};